export interface Transaction {
  id: number;
  type: string;
  date: string;
  paymentNumber: string;
  adNumber: string;
  service: string;
  paymentType: string;
  amount: number;
  totalAmount: number;
  ad?: {
    id: number;
    name: string;
    price: number;
    image: string;
  };
}

export const mockTransactions: Transaction[] = [
  {
    id: 1,
    type: 'account',
    date: '23.01.2021, 00:42',
    paymentNumber: '444',
    adNumber: '123456789',
    service: 'Пополнение баланса',
    paymentType: 'Банковская карта',
    amount: 100,
    totalAmount: 100,
  },
  {
    id: 2,
    type: 'ads',
    date: '23.01.2021, 00:42',
    paymentNumber: '32423',
    adNumber: '123456789',
    service: 'Поднять 15 раз',
    paymentType: 'Банковская карта',
    amount: 15,
    totalAmount: 15,
    ad: {
      id: 1,
      price: 2400,
      name: 'Apple iPhone 13 Pro Sierra Blue 128GB/6GB',
      image: '/images/mock-slide.png',
    },
  },
];
